export default __webpack_public_path__ + "bundles/mamotheme/images/pin.svg";